import { Divider } from "primereact/divider";
import { Image } from "primereact/image";
import { AddPageHeader } from "../Common/Utils";
import { Link } from "react-router-dom";
import { Card } from "primereact/card";
import cacLogo from "../../assets/images/CAC-logo.png";
import caLogo from "../../assets/images/CA-logo.png";

const SupportConsularResearch = () => {
  return (
    <div className="support-consular-research reduce-width">
      {AddPageHeader("Support consular research")}
      <Divider align="center">
        <h1>Support consular research</h1>
      </Divider>

      <div className="flex flex-wrap justify-content-center gap-4 mb-4">
        {/* Member Card */}
        <Card
          style={{
            border: "2px solid black",
            background: "#fff",
            color: "#000",
          }}
          className="card min-w-20rem max-w-25rem p-3 border-round-sm"
        >
          <Image src={caLogo} alt="Image" width="80" />
          <br />
          <br />
          <b>Become a Member</b>
          <div>(for organizations and individuals)</div>
          <br />
          <div
            style={{
              textAlign: "justify",
              textJustify: "inter-word",
            }}
          >
            <ul
              style={{
                listStyle: "square",
                listStylePosition: "outside",
                paddingInlineStart: "1.25rem",
                margin: 0,
              }}
            >
              <li>
                Join professionals and researchers in consular affairs,
                diplomacy, migration, security, and travel.
              </li>
              <li>
                Contribute and support consular research with no obligations on
                your side.
              </li>
              <li>Gain credibility and visibility.</li>
            </ul>
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <a
              href="https://consularassociation.org"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontWeight: "bold",
                width: "220px",
                maxWidth: "90%",
                textDecoration: "none",
              }}
            >
              <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
                <div>Visit the website</div>
              </div>
            </a>
          </div>
        </Card>

        {/* Partner Card */}
        <Card
          style={{
            border: "2px solid black",
            background: "#fff",
            color: "#000",
          }}
          className="card min-w-20rem max-w-25rem p-3 border-round-sm"
        >
          <Image src={cacLogo} alt="Image" width="80" />
          <br />
          <br />
          <b>Become a Partner</b>
          <div>(for organizations)</div>
          <br />
          <div
            style={{
              textAlign: "justify",
              textJustify: "inter-word",
            }}
          >
            <ul
              style={{
                listStyle: "square",
                listStylePosition: "outside",
                paddingInlineStart: "1.25rem",
                margin: 0,
              }}
            >
              <li>Support the Center as a whole.</li>
              <li>Contribute to an existing program.</li>
              <li>Or propose a new initiative.</li>
            </ul>
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Link
              to="/contact"
              style={{
                textDecoration: "none",
                color: "inherit",
                width: "220px",
                maxWidth: "90%",
              }}
            >
              <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
                <div>
                  <b>Contact the Center</b>
                </div>
              </div>
            </Link>
          </div>
        </Card>

        {/* Contributor Card */}
        <Card
          style={{
            border: "2px solid black",
            background: "#fff",
            color: "#000",
          }}
          className="card min-w-20rem max-w-25rem p-3 border-round-sm"
        >
          <Image src={cacLogo} alt="Image" width="80" />
          <br />
          <br />
          <b>
            Contribute to the Diplomatic and Consular Networks Database and
            Rankings
          </b>
          <div>(for media professionals and research organizations)</div>
          <br />
          <div
            style={{
              textAlign: "justify",
              textJustify: "inter-word",
            }}
          >
            <ul
              style={{
                listStyle: "square",
                listStylePosition: "outside",
                paddingInlineStart: "1.25rem",
                margin: 0,
              }}
            >
              <li>Help keep the database up to date.</li>
              <li>
                No obligations or quotas – send updates only when you are aware
                of them.
              </li>
              <li>
                <a
                  href="https://arcg.is/1TDPiy1"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "black",
                    textDecoration: "underline",
                  }}
                >
                  Visit
                </a>{" "}
                the GIS platform.
              </li>
            </ul>
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Link
              to="/contact"
              style={{
                textDecoration: "none",
                color: "inherit",
                width: "220px",
                maxWidth: "90%",
              }}
            >
              <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
                <div>
                  <b>Contact the Center</b>
                </div>
              </div>
            </Link>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default SupportConsularResearch;
